import { Injectable } from "@angular/core";
import { MessageService } from "primeng/api";

@Injectable({
  providedIn: "root",
})
export class ToastrService {
  constructor(private messageService: MessageService) {}

  success(detail: string, summary?: string): void {
    this.messageService.add({ severity: "success", summary, detail });
  }

  error(detail: string, summary?: string): void {
    this.messageService.add({ severity: "error", summary, detail });
  }

  info(detail: string, summary?: string): void {
    this.messageService.add({ severity: "info", summary, detail });
  }

  warning(detail: string, summary?: string): void {
    this.messageService.add({ severity: "warn", summary, detail });
  }

  clearMessages(): void {
    this.messageService.clear();
  }
}
